module.exports = __webpack_public_path__ + "static/media/livro.2042e31c.svg";